export default class SystemUtilities {

    public maskEmail(email) {
        if (!email || typeof email !== 'string') {
          throw new Error('Invalid email');
        }
      
        const atIndex = email.indexOf('@');
        
        if (atIndex === -1) {
          return email; // No "@" found, return original email
        }
      
        const localPart = email.substring(0, atIndex + 1); // Keep the local part along with "@"
        const domainPart = email.substring(atIndex + 1).replace(/./g, '#'); // Replace all characters of the domain with "#"
        
        return localPart + domainPart;
      }


      public maskPhoneNumber(phoneNumber) {
        if (!phoneNumber || typeof phoneNumber !== 'string') {
            throw new Error('Invalid phone number');
        }
    
        return phoneNumber.replace(/(\d{5})(\d+)/, function(_, firstSix, remainingNumbers) {
            return firstSix + remainingNumbers.replace(/\d/g, '#');
        });
    }

  }